import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type SurveyApprovalAction = 'submit' | 'approve' | 'reject' | 'request_revision';

export interface SurveyApprovalDialogData {
  projectName: string;
  action: SurveyApprovalAction;
  currentStatus: string;
}

@Component({
  selector: 'app-survey-approval-dialog',
  templateUrl: './survey-approval-dialog.component.html',
  styleUrls: ['./survey-approval-dialog.component.css'],
})
export class SurveyApprovalDialogComponent {
  form: FormGroup;

  readonly actionLabels: Record<SurveyApprovalAction, string> = {
    submit: 'Submit for approval',
    approve: 'Approve survey',
    reject: 'Reject survey',
    request_revision: 'Request revision',
  };

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SurveyApprovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SurveyApprovalDialogData
  ) {
    const notesRequired = data.action !== 'submit';
    this.form = this.fb.group({
      notes: ['', notesRequired ? Validators.required : []],
    });
  }

  get title(): string {
    return this.actionLabels[this.data.action];
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close({ notes: this.form.value.notes || '' });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
